module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.modalVisible === 'cant-export') ? _c('layout-general', {
    on: {
      "close": function($event) {
        return _vm.modalClose()
      }
    }
  }, [_c('h4', {
    staticClass: "modal-title",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('modal.cant_export_table.title')))]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('h4', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.$t('modal.cant_export_table.max_limit')) + _vm._s(_vm.reportExportLimit) + _vm._s(_vm.$t('modal.cant_export_table.select_interval')))])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.modalClose()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.close')))])])]) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-03bb9146!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/CantExportTable.vue
 ** module id = 747
 ** module chunks = 1
 **/